import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Head from 'next/head'
import { SessionProvider } from 'next-auth/react'
import React from 'react'

import { ToastProvider } from '@/components/ui/toast'

import type { AppProps } from 'next/app'

import '@/styles/globals.css'

export default function App({
  Component,
  pageProps: { session, ...pageProps }
}: AppProps) {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000
          }
        }
      })
  )

  return (
    <>
      <Head>
        <title>My Lines - Back Office</title>
      </Head>
      <SessionProvider session={session}>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <Component {...pageProps} />
          </ToastProvider>
        </QueryClientProvider>
      </SessionProvider>
    </>
  )
}
